/**
 *@file config.js
 *@version 1.0.1
 *@author wuwg
 *@createTime 2019/10/17 - 20:37
 *@updateTime 2019/10/17 - 20:37
 *@see [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 * @description    server-config.js.js ,所有服务器的url配置
 */
const dirServicePath = window.serverConfig.dirServicePath;
const aiPrefix = window.serverConfig.aiPrefix;
// 服务数据
const serverUrl = {
    login: category =>
        ({
            // 登录
            login: `${dirServicePath}/user/login`,
            // 校验token是否失效
            checkToken: `${dirServicePath}/user/checkToken`,

            rewardusergetRewardUserQcode: dirServicePath + +"/wxshare/getCompanyQcode", //企业获取微信二维码
            rewardUserQrCodeLogin: dirServicePath + "/user/companyQrCodeLogin", //企业轮寻结果
            rewardUserWXgetCode: dirServicePath + "/phonecode/companyQuickLogin", //绑定微信获取验证码

            rewarduserPhonecode: dirServicePath + "/phonecode/company/login", //企业登录获取验证码
            rewarduserQuickLogin: dirServicePath + "/company/login", //企业手机号验证码登录
            rewarduserLogin: dirServicePath + "/user/login", //企业账号密码登录

            rewarduserPhonecodeRegister: dirServicePath + "/phonecode/companyRegister", //企业注册获取验证码
            rewarduserRegister: dirServicePath + "/user/companyRegister", //企业注册

            rewarduserPhonecodeForgetPassword: dirServicePath + "/phonecode/forgetPassword", //企业忘记密码获取验证码
            rewarduserForgetPassword: dirServicePath + "/user/companyForgetPassword" //企业找回密码
        }[category]),
    common: category =>
        ({
            // 上传
            upload: `${dirServicePath}/upload/admin/uploadFile`,
            //websoket
            // webSocket
            webSocket: `${dirServicePath}/webSocket/`,
            // 行业领域
            hangyelingyu: `${dirServicePath}/dictionary/hangyelingyu`,
            // 管家二维码
            guanjia: `${dirServicePath}/dictionary/guanjia`,

            //人才详情获取手机号
            programmerPhone: `${dirServicePath}/company/programmer/programmerPhone`,
            //通过workOrderId获取手机号
            orderProgrammerPhone: `${dirServicePath}/workorder/company/programmerPhone`,
            //聊一聊动态
            liaoyiliaoUpdates: `${dirServicePath}/workorder/company/liaoyiliaoUpdates`,
        }[category]),
    home: category =>
        ({
            // 提交收集信息
            submitInfo: `${dirServicePath}/company/info/submitInfo`,
            // 提交认证信息
            submitAuth: `${dirServicePath}/company/info/submitAuth`,
            // 获取用户信息
            getInfo: `${dirServicePath}/company/info/getInfo`,
            // 认证信息
            myAuth: `${dirServicePath}/company/info/myAuth`,
            // 企业资料
            authInfo: `${dirServicePath}/company/info/authInfo`,
            // 雇佣名片信息
            baseInfo: `${dirServicePath}/company/info/baseInfo`,
            // 上传营业执照
            uploadYingyezhizhao: `${dirServicePath}/upload/company/uploadYingyezhizhao`,
            // 提交认证信息获取验证码
            auth: `${dirServicePath}//phonecode/company/info/auth`,
            // 提交认证信息获取验证码
            checkCompanyName: `${dirServicePath}/company/info/checkCompanyName`,
            // 推荐类别
            getRecommendC: `${dirServicePath}/dictionary/getRecommendC`,
            // 普通分享
            shareOrder: `${dirServicePath}/programmer/share/getShareCode`,

            // 提交/修改 招聘名片信息
            submitInfo2: `${dirServicePath}/company/info/submitInfo`,
            // 提交 岗位信息
            submitWorkInfo: `${dirServicePath}/company/info/submitWorkInfo`,
            // 已读认证
            readAuth: `${dirServicePath}/company/info/readAuth`,
            // 导航
            navigation: `${dirServicePath}/company/info/navigation`,
            // 导航岗位
            getRecommendC: `${dirServicePath}/dictionary/getRecommendC`,
            //智工列表
            programmerList: `${dirServicePath}/company/programmer/programmerList`,
            //收藏/取消收藏人才
            favorite: `${dirServicePath}/company/programmer/favorite`,
            getLabel2: `${dirServicePath}/dictionary/getLabel2`,
            companyAIWorkList: `${dirServicePath}/work/company/companyAIWorkList`,
            //人才详情
            getProgrammer: `${dirServicePath}/company/programmer/getProgrammer`,
            //按岗位类型发布的工作内容
            companyWorkListByLabelId2: `${dirServicePath}/work/company/companyWorkListByLabelId2`,
            //邀请聊一聊
            inviteOrder: `${dirServicePath}/workorder/company/inviteOrder`,
            //取消、拒绝
            cancelInviteDeliver: `${dirServicePath}/workorder/company/cancelInviteDeliver`,
            //约面查岗位
            orderInfo: `${dirServicePath}/workorder/company/orderInfo`,
            //约面查岗位
            inviteInterview: `${dirServicePath}/workorder/company/inviteInterview`,
            //pc查询营销位图片
            selectpc: `${dirServicePath}/company/banner/selectpc`,
            //发岗前获取报价
            getPrice: `${dirServicePath}/quotation/company/getPrice`,

            //发岗前获取报价
            getPrice: `${dirServicePath}/quotation/company/getPrice`,
            //发岗前获取报价
            getPrice: `${dirServicePath}/quotation/company/getPrice`,


        }[category]),

    msgl: category =>
        ({
            // 面试列表
            getDeliverList: `${dirServicePath}/deliver/getDeliverList`,
            // 修改状态
            updateDeliver: `${dirServicePath}/deliver/qiyeUpdateDeliver`,
            // 反馈记录列表
            getDeliverRecord: `${dirServicePath}/deliver/getDeliverRecord`,
            // 面试导出
            getDeliverExcel: `${dirServicePath}/deliver/getDeliverExcel`,
            // 批量导出简历
            qiyePackageDeliver: `${dirServicePath}/deliver/qiyePackageDeliver`,
            // 面试日程
            qiyeMianshi: `${dirServicePath}/backlog/companySchedule`,
            // 待办数量
            qiyeDaiBanCount: `${dirServicePath}/backlog/qiyeDaiBanCount`,
            // 批量未通过
            qiyeMultiUpdateDeliver: `${dirServicePath}/deliver/qiyeMultiUpdateDeliver`,
            //下载过的简历标记已读
            insertDeliverDownload: `${dirServicePath}/deliver/insertDeliverDownload`,
            //获取企业预约时段
            qiyePackageRuzhiCailiao: `${dirServicePath}/deliver/qiyePackageRuzhiCailiao`,
            qiyeBookAvailable: `${dirServicePath}/deliver/qiyeBookAvailable`,
            //取消面试
            cancelMianshi: `${dirServicePath}/backlog/cancelMianshi`,
            //获取缓存联系人
            selectContactList: `${dirServicePath}/contact/selectContactList`,
            // 面试官列表
            getInterviewerList: `${dirServicePath}/interviewer/getInterviewerList`,
            // 面试官新增
            addInterviewer: `${dirServicePath}/interviewer/addInterviewer`,
            // 面试官时刻表
            getInterviewerBook: `${dirServicePath}/interviewer/getInterviewerBook`,
            // 企业通过简历
            passResume: `${dirServicePath}/deliver/company/passResume`,
            // 企业修改面试
            changeBook: `${dirServicePath}/deliver/company/changeBook`,
            // 查看当前面试官所有面试
            getAllInterviewerBookList: `${dirServicePath}/interviewer/getAllInterviewerBookList`,
            // 企业确认
            confirmBook: `${dirServicePath}/deliver/company/confirmBook`,
            // 企业预约时间记录
            timeList: `${dirServicePath}/deliver/company/timeList`,
            // 企业邀请复试
            inviteSecondInterview: `${dirServicePath}/deliver/company/inviteSecondInterview`,
            // 企业拒绝面试
            cancelDeliver: `${dirServicePath}/deliver/company/cancelDeliver`,
            // 企业查看新简历
            checkDeliver: `${dirServicePath}/deliver/company/checkDeliver`,
            // 企业拒绝材料
            refuseFile: `${dirServicePath}/deliver/company/refuseFile`,
            // 企业通过材料
            passFile: `${dirServicePath}/deliver/company/passFile`,

            // 企业通过材料
            confirmEnter: `${dirServicePath}/deliver/company/confirmEnter`,

            // 企业不通过简历
            failResume: `${dirServicePath}/deliver/company/failResume`,
            // 企业不通过面试
            failInterview: `${dirServicePath}/deliver/company/failInterview`,
            //企业通过面试/复试
            passInterview: `${dirServicePath}/deliver/company/passInterview`,
            //企业取消面试
            cancelInterviewer: `${dirServicePath}/deliver/company/cancelInterviewer`,
            //企业取消入职
            refuseEnter: `${dirServicePath}/deliver/company/refuseEnter`
        }[category]),

    gwgl: category =>
        ({
            // 岗位列表
            gwglselectJob: `${dirServicePath}/job/selectJob`,
            // 热门岗位
            gwglhotJobList: `${dirServicePath}/job/hotJobList`,
            // 下载模板
            gwglgetExcelMould: `${dirServicePath}/job/getMould`,
            //添加崗位
            gwglInsertUser: `${dirServicePath}/job/publish`,
            //子账号添加崗位
            insertJobPre: `${dirServicePath}/jobpre/insertJobPre`,
            // 导入岗位
            gwglgetExcelDr: `${dirServicePath}/job/multiAdd`,
            //技能标签
            gwgllableList: `${dirServicePath}/dictionary/skillLabel`,
            //学历
            gwglxueliList: `${dirServicePath}/dictionary/education`,
            //岗位等级
            gwgldengjiList: `${dirServicePath}/dictionary/level`,
            //经验
            gwgljingyanList: `${dirServicePath}/dictionary/workExperience`,
            //省市
            gwglSSQList: `${dirServicePath}/cnregioninfo/pca`,
            // 导出岗位
            gwglgetJobExcel: `${dirServicePath}/job/getJobExcel`,
            // 岗位详情
            gwgljobDetail: `${dirServicePath}/job/jobDetail`,
            //催单
            gwgljobcd: `${dirServicePath}/job/cuidan`,
            // 结束
            gwglupdateJob: `${dirServicePath}/job/updateJob`,
            //供应商列表
            getGongyingshangWhenPublishJob: `${dirServicePath}/user/getGongyingshangWhenPublishJob`,
            //审核报价
            qiyeUpdateJobOrder: `${dirServicePath}/joborder/qiyeUpdateJobOrder`,
            //岗位还可同步供应商列表job/getLeftGongyingshangByJob
            getLeftGongyingshangByJob: `${dirServicePath}/job/getLeftGongyingshangByJob`,
            //立即同步供应商
            jobAddGongyingshang: `${dirServicePath}/job/jobAddGongyingshang`,
            //激活岗位
            jihuoJob: `${dirServicePath}/job/jihuoJob`,
            //修改邮箱
            updateJobEmail: `${dirServicePath}/job/updateJobEmail`,
            //获取城市列表
            city: `${dirServicePath}/cnregioninfo/city`,
            //获取技能标签
            getLableList: `${dirServicePath}/dictionary/getLableList`,
            //修改岗位
            xiugaiJob: `${dirServicePath}/job/xiugaiJob`,
            //下载岗位下所有简历
            qiyePackageDeliverByJob: `${dirServicePath}/deliver/qiyePackageDeliverByJob`,
            //查询预约时间
            qiyeBookAvailableByJobId: `${dirServicePath}/job/qiyeBookAvailableByJobId`,
            //更新预约时间
            qiyeUpdateBookAvailable: `${dirServicePath}/job/qiyeUpdateBookAvailable`,
            //获取签约岗位
            selectJobRequire: `${dirServicePath}/jobrequire/selectJobRequire`,
            //普通岗位获取价格，描述
            getPrice: `${dirServicePath}/job/getPrice`,
            //获取二级类别
            getSkillLableByName: `${dirServicePath}/dictionary/getSkillLableByName`,
            // 获取关键词
            getLabel: `${dirServicePath}/dictionary/getLabel`,
            // 发布岗位
            publishWork: `${dirServicePath}/work/company/publishWork`,
            // 岗位列表
            workList: `${dirServicePath}/work/company/workList`,

            // 预约列表
            getOrderByWorkId: `${dirServicePath}/workorder/company/getOrderByWorkId`,

            // 预约详情
            getOrder: `${dirServicePath}/workorder/company/getOrder`,

            // 预约面试
            setInterview: `${dirServicePath}/workorder/company/setInterview`,

            // 拒绝
            refuseOrder: `${dirServicePath}/workorder/company/refuseInterview`,
            // 已读
            readOrder: `${dirServicePath}/workorder/company/readOrder`,
            // 面试安排列表
            getInterview: `${dirServicePath}/workorder/company/getInterview`,
            // 获取是否新下单
            preOrder: `${dirServicePath}/workorder/company/preOrder`,

            // 下单
            placeOrder: `${dirServicePath}/workorder/company/placeOrder`,
            // 上传汇款照片
            uploadRemit: `${dirServicePath}/upload/company/uploadRemit`,
            // 钱包
            getWallet: `${dirServicePath}/wallet/company/getWallet`,

            // 支付宝付款
            aliPay: `${dirServicePath}/workorder/company/aliPay`,
            // 微信付款
            wechatPay: `${dirServicePath}/workorder/company/wechatPay`,

            // 汇款支付
            remitPay: `${dirServicePath}/workorder/company/remitPay`,

            // 获取支付结果
            getPayResult: `${dirServicePath}/workorder/company/getPayResult`,

            // 钱包支付
            walletPay: `${dirServicePath}/workorder/company/walletPay`,

            // 汇款支付
            haveRule: `${dirServicePath}/attendanceRule/haveRule`,

            // 提出终止订单
            finishOrder: `${dirServicePath}/workorder/company/finishOrder`,
            // 提出终止订单
            stopOrder: `${dirServicePath}/workorder/company/stopOrder`,
            // 取消订单
            cancelOrder: `${dirServicePath}/workorder/company/cancelOrder`,
            // 确认完成订单
            confirmOrder: `${dirServicePath}/workorder/company/confirmFinishOrder`,
            // 确认取消订单
            confirmStopOrder: `${dirServicePath}/workorder/company/confirmStopOrder`,
            // 确认到岗
            confirmEnter: `${dirServicePath}/workorder/company/confirmEnter`,


            // 发布的工作内容
            getCompanyWorkList: `${dirServicePath}/work/company/companyWorkList`,
            // 开启/关闭岗位
            openCloseWork: `${dirServicePath}/work/company/openCloseWork`,
            // 删除岗位
            deleteWork: `${dirServicePath}/work/company/deleteWork`,
            // 岗位详情
            getWorkDetail: `${dirServicePath}/work/company/workDetail`,
            // 编辑岗位
            updateWork: `${dirServicePath}/work/company/updateWork`,
            // 发布AI匹配岗位
            publishAIWork: `${dirServicePath}/work/company/publishAIWork`,
            // 发布的岗位标题
            companyWorkTitleList: `${dirServicePath}/work/company/companyWorkTitleList`,
            //已匹配的列表
            deliverList: `${dirServicePath}/workorder/company/deliverList`,
            //AI推荐列表
            retrievalProgrammer: aiPrefix + "/programmer/resume/retrieval-programmer", //workId=270
            //聊一聊列表
            getLiaoyiliaoList: `${dirServicePath}/workorder/company/liaoyiliaoList`,

            //AI重新匹配
            refuseDeliver: `${dirServicePath}/workorder/company/refuseDeliver`,
            //AI关闭匹配
            closeDeliver: `${dirServicePath}/workorder/company/closeDeliver`,
            //查看邀请内容
            getOrderInfo: `${dirServicePath}/workorder/company/orderInfo`,
            //取消/拒绝聊一聊
            cancelInviteDeliver: `${dirServicePath}/workorder/company/cancelInviteDeliver`,
            //选人下单
            directOrder: `${dirServicePath}/workorder/company/directOrder`,
        }[category]),

    xtxx: category =>
        ({
            // 系统通知接口
            getMessageList: `${dirServicePath}/message/getMessageList`,
            // 读消息
            readMessage: `${dirServicePath}/message/readMessage`,
            // 删消息
            delMessage: `${dirServicePath}/message/deleteMessage`,
            //日历待办查询
            monthAnpai: `${dirServicePath}/backlog/monthAnpai`,
            //今日面试安排
            todayAnpai: `${dirServicePath}/backlog/todayAnpai`,
            //一键已读
            readAllMessage: `${dirServicePath}/message/readAllMessage`
        }[category]),

    account: category =>
        ({
            // 订单列表
            orderList: `${dirServicePath}/workorder/company/orderList`,
            getRule: `${dirServicePath}/attendanceRule/getRule`,
            setRule: `${dirServicePath}/attendanceRule/setRule`,
            getStaffWorkRecordList: `${dirServicePath}/attendance/company/getAttendanceList`,
            getWorkRecordList: `${dirServicePath}/attendance/company/getWorkRecordList`,
            staffWorkRecordByMonth: `${dirServicePath}/workrecord/company/staffWorkRecordByMonth`,
            workStaffList: `${dirServicePath}/workstaff/company/workStaffList`,
            workRecordExcel: `${dirServicePath}/attendance/company/workRecordExcel`,
            //
            rateOrder: `${dirServicePath}/workorder/company/rateOrder`,
            orderRenewal: `${dirServicePath}/workorder/company/orderRenewal`,
            cancelRenewal: `${dirServicePath}/workorder/company/cancelRenewal`,

            suggestion: `${dirServicePath}/qqmap/suggestion`, //地点搜索
            deleteRule: `${dirServicePath}/attendanceRule/deleteRule`, //删除考勤
            setRule: `${dirServicePath}/attendanceRule/setRule`, //设置/修改考勤


        }[category]),


    //钱包相关接口
    wallet: category =>
        ({
            getWallet: `${dirServicePath}/wallet/company/getWallet`,
            getWalletRecordList: `${dirServicePath}/wallet/company/walletRecordList`,
            depositRemit: `${dirServicePath}/wallet/company/depositRemit`,
            wechatPay: `${dirServicePath}/wallet/company/wechatPay`,
            aliPay: `${dirServicePath}/wallet/company/aliPay`,
            withdrawApply: `${dirServicePath}/wallet/company/withdrawApply`,
            getPayResult: `${dirServicePath}/wallet/company/getPayResult`,

            getStatementList: `${dirServicePath}/workstatement/company/getStatementList`,
            getStatementInvoiceList: `${dirServicePath}/workstatement/company/getStatementInvoiceList`,
            getLaseInvoiceInfo: `${dirServicePath}/workstatement/company/getLaseInvoiceInfo`,
            issueInvoice: `${dirServicePath}/workstatement/company/issueInvoice`,
            getStatementInvoice: `${dirServicePath}/workstatement/company/getStatementInvoice`,
            confirmStatement: `${dirServicePath}/workstatement/company/confirmStatement`,
            getStatement: `${dirServicePath}/workstatement/company/getStatement`,

            prePay: `${dirServicePath}/workorder/company/prePay`,
            afterPay: `${dirServicePath}/workorder/company/afterPay`,
            remitRepayment: `${dirServicePath}/wallet/company/remitRepayment`,
            wechatRepayment: `${dirServicePath}/wallet/company/wechatRepayment`,
            aliRepayment: `${dirServicePath}/wallet/company/aliRepayment`,

            phonecodeWalletPay: `${dirServicePath}/phonecode/company/walletPay`, //钱包支付-获取验证码
            phonecodeCreditPay: `${dirServicePath}/phonecode/company/creditPay`, //授信支付-获取验证码

            walletPay: `${dirServicePath}/workorder/company/walletPay`, // 钱包支付
            creditPay: `${dirServicePath}/workorder/company/creditPay`, //授信支付

            //获取银行卡
            bankCardList: `${dirServicePath}/bank/company/bankCardList`,
            //获取是否可以删除/换绑
            preChange: `${dirServicePath}/bank/company/preChange`,

            //绑卡-账号校验获取验证码
            bindBankCardAuthStr: `${dirServicePath}/phonecode/company/bindBankCard/authStr`,
            //绑卡-验证验证码
            bindBankCardGetAuthStr: `${dirServicePath}/bank/company/bind/getAuthStr`,
            //绑卡
            bindBankCard: `${dirServicePath}/bank/company/bindBankCard`,

            //换绑-账号校验获取验证码
            changeBankCardAuthStr: `${dirServicePath}/phonecode/company/changeBankCard/authStr`,
            //换绑-验证验证码
            changeBankCardGetAuthStr: `${dirServicePath}/bank/company/change/getAuthStr`,
            //换绑
            changeBankCard: `${dirServicePath}/bank/company/changeBankCard`,

            //删除-账号校验获取验证码
            deleteBankCardAuthStr: `${dirServicePath}/phonecode/company/deleteBankCard/authStr`,
            //删除-验证验证码
            deleteBankCardGetAuthStr: `${dirServicePath}/bank/company/delete/getAuthStr`,
            //删除
            deleteBankCard: `${dirServicePath}/bank/company/deleteBankCard`,

            walletRecordDetail: `${dirServicePath}/wallet/company/walletRecordDetail`,

        }[category]),

    // 待办
    approval: category =>
        ({
            approvalList: `${dirServicePath}/approval/company/approvalList`, //代办列表
            getWorkOver: `${dirServicePath}/workrecord/company/getWorkOver`, //获取加班申请
            handleWorkOver: `${dirServicePath}/workrecord/company/handleWorkOver`, //处理加班申请
            getFill: `${dirServicePath}/workrecord/company/getFill`, //获取补卡申请
            handleFill: `${dirServicePath}/workrecord/company/handleFill`, //处理补卡申请
            getWorkLeave: `${dirServicePath}/workrecord/company/getWorkLeave`, //获取请假申请
            handleWorkLeave: `${dirServicePath}/workrecord/company/handleWorkLeave`, //处理请假申请
            getWorkReimbursement: `${dirServicePath}/workrecord/company/getWorkReimbursement`, //获取报销申请
            handleWorkReimbursement: `${dirServicePath}/workrecord/company/handleWorkReimbursement`, //处理报销申请

        }[category]),
    useredit: category =>
        ({
            getInfo: `${dirServicePath}/company/info/getInfo`,
            updateInfo: `${dirServicePath}/company/info/updateInfo`,
            getCompanyByToken: `${dirServicePath}/company/getCompanyByToken`,
            goGetAuthStr: `${dirServicePath}/phonecode/company/getAuthStr`,
            getAuthStr: `${dirServicePath}/company/getAuthStr`,
            changePhone: `${dirServicePath}/phonecode/company/changePhone`,
            changePhones: `${dirServicePath}/company/changePhone`,
        }[category]),
    message: category =>
        ({
            noticeList: `${dirServicePath}/notice/company/noticeList`,
            read: `${dirServicePath}/notice/company/read`, //读消息
            readAll: `${dirServicePath}/notice/company/readAll`, //一键读消息
        }[category]),
    rcgl: category =>
        ({
            getProgrammerList: `${dirServicePath}/company/programmer/programmerList`, //人才列表
            getFavoriteProgrammerList: `${dirServicePath}/company/programmer/favoriteProgrammerList`, //感兴趣的人才列表
            getProgrammer: `${dirServicePath}/company/programmer/getProgrammer`, //人才详情
            getLabel2: `${dirServicePath}/dictionary/getLabel2`, //岗位类型
            favorite: `${dirServicePath}/company/programmer/favorite`, //收藏/取消收藏人才
            inviteOrder: `${dirServicePath}/workorder/company/inviteOrder`, //邀请聊一聊
            inviteInterview: `${dirServicePath}/workorder/company/inviteInterview`, //约面试

        }[category]),

};
export default serverUrl;



// WEBPACK FOOTER //
// ./src/js/server-config.js